import { render } from "./Disbursements.vue?vue&type=template&id=e46a3f10"
import script from "./Disbursements.vue?vue&type=script&lang=js"
export * from "./Disbursements.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__